const actions = {
    DATASOURCE_ADD_NEW: 'DATASOURCE_ADD_NEW',
    DATASOURCE_READ: 'DATASOURCE_READ',
    DATASOURCE_READ_SUCCESS: 'DATASOURCE_READ_SUCCESS',
    DATASOURCE_UPDATE: 'DATASOURCE_UPDATE',
    DATASOURCE_FIND_BY_ID: 'DATASOURCE_FIND_BY_ID',
    DATASOURCE_LIST_SUCCESS: 'DATASOURCE_LIST_SUCCESS',
    DATASOURCE_ITEM_SUCCESS: 'DATASOURCE_ITEM_SUCCESS',

    
    dataSourceAddNew:(history, dataObj) => ({ //Action creator function
      type: actions.DATASOURCE_ADD_NEW, //Action
      payload: { history, dataObj } //pass payload to action, we should pass as little data to action
    }),

    dataSourceRead:(readFilter, page) => ({ //Action creator function
      type: actions.DATASOURCE_READ, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    // onPageChange: (info, page) => ({
    //   type: actions.DATASOURCE_READ,
    //   payload: { info, page }
    // }),
    onPageChange: (readFilter, page) => ({
      type: actions.DATASOURCE_READ,
      payload: { readFilter, page }
    }),
    dataSourceReadSearchSuccess: (data, success, total_count, page) => ({
      type: actions.DATASOURCE_READ_SUCCESS,
      data,
      success,
      total_count,
      page,
    }),

    dataSourceFindById: (dataSourceId) => ({
      type: actions.DATASOURCE_FIND_BY_ID,
      payload: { dataSourceId }
    }),

  

  };
  export default actions;